import Vue from 'vue';
import Vuex from 'vuex';

import adminLayout from './admin/layout';
import doctorLayout from './doctor/layout';

import doctorAuth from './doctor/auth';
import adminAuth from './admin/auth';
import doctorCheckup from './doctor/checkup';

import generalUserAuth from './general_user/auth';
import generalUserCheckup from './general_user/checkup';
import generalUserDoctor from './general_user/doctor';



Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
      adminAuth,
      adminLayout,
      doctorLayout,
      doctorAuth,
      doctorCheckup,
      generalUserAuth,
      generalUserCheckup,
      generalUserDoctor
  },
});
